import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import HtmlFromLangFile from "../../01-atoms/HtmlFromLangFile/HtmlFromLangFile";

import { NWONFaqProps } from "./NWONFaqInterfaces";
import { useNWONFaqStyles } from "./NWONFaqStyles";

export const NWONFaq = (props: NWONFaqProps): JSX.Element | null => {
  const { classes } = useNWONFaqStyles();

  if (props.entries.length === 0) {
    return null;
  }

  return (
    <>
      {props.entries.map((entry) => (
        <Accordion
          key={entry.title}
          defaultExpanded={entry.initiallyExpanded || false}
          className={classes.accordion}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls={entry.title}
            id={entry.title}
            className={classes.accordionSummary}
          >
            <HtmlFromLangFile contentContainingHtml={entry.title} />
          </AccordionSummary>

          <AccordionDetails>
            <Typography>
              <HtmlFromLangFile contentContainingHtml={entry.description} />{" "}
            </Typography>
          </AccordionDetails>
        </Accordion>
      ))}
    </>
  );
};
